/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderArrowDownLeft: {
  name: 'folder-arrow-down-left';
  data: string;
} = {
  name: 'folder-arrow-down-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3a.5.5 0 0 1 .5-.5h3.586a.5.5 0 0 1 .353.146l1.415 1.415a1.5 1.5 0 0 0 1.06.439H14a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H9a.5.5 0 0 0 0 1h5a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 14 3.5H8.414a.5.5 0 0 1-.353-.146L6.646 1.939a1.5 1.5 0 0 0-1.06-.439H2A1.5 1.5 0 0 0 .5 3v3a.5.5 0 0 0 1 0V3Zm0 6a.5.5 0 0 0-1 0v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H2.207l4.147-4.146a.5.5 0 1 0-.708-.708L1.5 12.793V9Z" fill="currentColor"/></svg>`,
};
